import { render, staticRenderFns } from "./TheSectionsTable.vue?vue&type=template&id=3a39ab54&scoped=true"
import script from "./TheSectionsTable.vue?vue&type=script&lang=js"
export * from "./TheSectionsTable.vue?vue&type=script&lang=js"
import style0 from "./TheSectionsTable.vue?vue&type=style&index=0&id=3a39ab54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39ab54",
  null
  
)

export default component.exports